import { useEffect, useState } from 'react';
import { fmtDateLong } from '../lib/datetime.js';

export default function Header({ deviceName }) {
  // Re-render once per minute so the date ticks over at midnight without
  // requiring a page reload (the iPad is on 24/7).
  const [today, setToday] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setToday(new Date()), 60_000);
    return () => clearInterval(t);
  }, []);
  return (
    <header className="bg-cathay-700 text-white px-6 py-3 flex items-center justify-between">
      <div className="text-kiosk font-semibold tracking-wide">IPT Sign-in</div>
      <div className="text-kiosk opacity-90">{fmtDateLong(today)}</div>
      <div className="text-kiosk opacity-90">{deviceName || '—'}</div>
    </header>
  );
}
